/** Created by Naveen on 24th Nov 2022
 * This file maintains the API response message and other constant values
 * Currently this file used only in @mp-fresh-case-component.ts file
 */

export const AADHAAR = "aadhaar";
export const ID = "id";
export const MOBILE_NUM_NTB = "mobileNoNTB";
export const AADHAAR_NUM_NTB = "aadhaarNTB";
export const MESSAGE_SUCCESS = "Success"
export const INVALID_OTP = "Invalid OTP";
export const OTP_EXPIRED = "OTP Expired";
export const MOBILE_NUM_INVALID = "Invalid mobile number";
export const MILE_STONE = {
    LOAN_REF: "loanRefNoGenerated",
    SATSURE_REPORT: "satsureReportGenerated",
    SATSURE_FAILED: "satsureReportFailed",
    CROP_PATTERN: "cropPatternSubmitted",
    LOAN_AMOUNT: "loanAmountCalculated",
    DOCS_EXEC: "docsExecuted",
    DOCS_EXEC_REQ: "docsExecutedRequest",
    LOAN_DISBURSED: "loanDisbursed"
};
export const PLEASE_USE_RESUME = "A record for the entered  Customer ID/ Account Number/ Aadhaar Number already exists. Please use the resume application button to complete your loan application process."
export const MPLRS_DOWNTIME_TEXT = "एमपीएलआरएस द्वारा सेवाएँ उपलब्ध न होने के कारण मध्य प्रदेश राज्य के लिए डिजिटल केसीसी सेवाएँ दिनांक 09.04.2023 तक उपलब्ध नहीं रहेंगी। अतः केसीसी ऋण स्वीकृति हेतु कृपया अपनी शाखा से संपर्क करें। असुविधा के लिए खेद है।    Due to non-availability of services from MPLRS, the Digital KCC services will not be available for Madhya Pradesh State up to 09/04/2023. Kindly contact your Branch for your KCC loan sanction. Inconvenience caused is regretted. ";
export const CREDIT_FETCH_FAIL = "Failed to fetch credit report";
export const CREDIT_FETCH_FAIL_HINDI = "क्रेडिट रिपोर्ट लाने में विफल";
export const TECH_ERROR = "Technical Error";
export const MESSAGE_FAILURE = "Failure";
export const MESSAGE_INVALID_REQUEST = "Invalid Request";
export const MESSAGE_NO_RES_UIADI = "No Response From UIDAI";
export const MESSAGE_OTP_NOT_GEN = "Could not generate and send OTP";
export const MESSAGE_EXISTING_CUST = "Failure as existing customer is from ETB";
export const MESSAGE_EXIST_KCC_LOAN = "ERR005 - Customer id has outstanding KCC Loan.";
export const MESSAGE_NPA_ACCOUNT = "ERR004 - Customer id has NPA Account.";
export const MESSAGE_DORMAT_ACCOUNT = "ERR054 - Customer having dormant saving accounts.";
export const MESSAGE_INVALID_AADHAR = "Invalid aadhaar number/Virtual Id";
export const MESSAGE_ALREADY_EXISTS = "Already exists";
export const MESSAGE_INVALID_MOB_NO = "Invalid mobileNo";
export const MESSAGE_AADHAR_DOE_NOT_MATCH = "The entered Aadhaar Number and the Aadhaar number as per the Bank Records Do Not Match. Kindly Contact the Branch for the further process.";
export const MESAGE_MOBILE_NUM_NOT_FOUND = "Kindly contact your Branch and update your records to proceed further";
export const AGRI_NESL = "AGRL";
export const SOMETHING_WENT_WRONG = "Something went wrong";
export const UNAUTHORIZED_ACCESS = "Unauthorized Access";
export const MESSAGE_INTERNAL_SERVER_ERRRO = "Internal Server Error";
export const MESSAGE_FINACLE_ERROR = "Finacle System Error Occoured!!! Please contact System Administrator.";
export const MINOR_ILLITERATE = "Customer is marked as Blind/Illiterate/ Lunatic/Minor/Deceased in Bank record, cannot proceed further. Kindly visit the Branch."
export const MINOR_ILLITERATE_ARRAY = [

    "Customer is ILLITERATE.",

    "Customer is LUNATIC.",

    "Customer is BLIND.",

    "Minor customers are not eligible",

    "Customer is DECEASED.",
]

export const ERROR_SET = [
    {
        CBS_MESSAGE: "ERR005 - Customer id has outstanding KCC Loan.",
        DISPLAY_MESSAGE: "Customer ID has KCC loan outstanding with Bank, cannot proceed further. Kindly visit the Branch"
    },
    
    {
        CBS_MESSAGE: "ERR054 - Customer having dormant saving accounts.",
        DISPLAY_MESSAGE: "Customer ID has Dormant/Freezed/Suspended Account in Bank record, cannot proceed further. Kindly visit the Branch"
    },
    
    {
        CBS_MESSAGE: "ERR004 - Customer id has NPA Account.",
        DISPLAY_MESSAGE: "Customer ID has NPA account with Bank, cannot proceed further. Kindly visit the Branch"
    },
    
    {
        CBS_MESSAGE: "ERR002 - Customer id is suspended.",
        DISPLAY_MESSAGE: "Customer ID has Dormant/Freezed/Suspended Account in Bank record, cannot proceed further. Kindly visit the Branch"
    },
    
    {
        CBS_MESSAGE: "Staff is not eligible",
        DISPLAY_MESSAGE: "Staff is not eligible for the journey, Kindly visit the Branch"
    }
]

export const FRUITS_API_STATUS_TEXT = {
    FARMER_ID_NOT_FOUND: "Farmer Id Not exists",
    AADHAR_NOT_VALIDATED: "Aadhaar Not Validated"
};
export const STATE_LIST = {
    MP: 'Madhya Pradesh',
    KA: 'Karnataka'
}
export const BRE_STATUS_DUPLICATE_ID = "Failed due to Duplicate Khasra No Entry"
export const DUPLI_KHASRA_FAIL = "Failed due to Duplicate Khasra No Entry"

export const MISSING_MESSAGE = {
    mobile: "Mobile number",
    mobile_hindi: "",
    name: "Applicant Name",
    name_hindi: "",
    sanctionedAmt: "Sanctioned Loan Amount",
    sanctionedAmt_hindi: "",
    referenceNo: "Loan Reference Number",
    referenceNo_hindi: ""
}

export const INVALID_SNCTNNO = "Invalid snctnno"
export const CHECK_STATUS = "Check Account Status"
export const CHECK_STATUS_KD = "ಖಾತೆಯ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ"
export const CHECK_STATUS_HINDI = "खाता स्थिति जांचें"
export const CHECK_STATUS_MARATHI = "खाते स्थिती तपासा"
export const FIVE_MINUTES_IN_MS = 300000
export const ONE_MINUTE_IN_MS = 60000

export const POPUP_IMG_TYPE = "popUpmageType"
export const POPUP_IMG_TYPE_PROFILE = "profileVerified"
export const POPUP_IMG_TYPE_AADHAR = "aadharVerified"
export const POPUP_IMG_TYPE_NESL = "neslVerified"
export const POPUP_IMG_TYPE_ACC_OPENING = "submitForLoanAccount"
export const FAILED_TO_FETCH_DIST = "Failed to fetch district information. Please try again later."

export const STATES = {
    "MP": {
        "POSSIBILITIES": ["madya pradesh", "madhya pradesh", "mp", "madyapradesh", "madhyapradesh"],
        "ENABLED": true,
        "KEY": "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1"
    },
    "KA": {
        "POSSIBILITIES": ["ka", "kar", "karnataka","KA"],
        "ENABLED": true,
        "KEY": "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y"
    },
    "UP": {
        "POSSIBILITIES": ["up", "uttar pradesh", "uttarpradesh","UP"],
        "ENABLED": false,
        "KEY": "Uq4YVODcoCruRMHy8lCFRPFbAf8d4uP8"
    },
    "MH": {
        "POSSIBILITIES": ["mh", "maharastra", "maha rastra", "maharashtra", "maha rashtra"],
        "ENABLED": true,
        "KEY":"fPWMHrmB1qRhPu2bOIT9LlGcAugp8cM6",
    },
    "AD": {
        "POSSIBILITIES": ["ad", "andra", "andhara", "andra pradesh","AD","andhra pradesh"],
        "ENABLED": true,
        "KEY": "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6"
    },
    "TL": {
        "POSSIBILITIES": ["telangana"],
        "ENABLED": true
    },
    "OD": {
        "POSSIBILITIES": ["od", "odisha", "orissa", "OD", "ODISHA", "ORISSA"],
        "ENABLED": true,
        "KEY": "2HeSroDFbNjOyhnwVO4WV90Gu2ET1QsZ"
    },
    "TN": {
        "POSSIBILITIES": ["tn", "tamilnadu","tamil nadu","Tamil Nadu","TAMIL NADU","TN"],
        "ENABLED": true,
        "KEY": "tNteP4U71cOhlWNlpGF5F9vkWkUFtmMy"
    },
    "RJ":{
        "POSSIBILITIES":["rj", "rajasthan", "Rajasthan", "RAJASTHAN", "RJ","rajastan","RAJASTAN", "Rajastan"],
        "ENABLED":true,
        "KEY":"Rs3dWqiFcIvLvRNFneH8wSRduQF28UhJ"
    },
    "GJ":{
        "POSSIBILITIES":["gj", "GJ", "gujarat", "Gujarat", "GUJARAT", "gujarath", "Gujarath", "GUJARATH", "gujrat", "Gujrat", "GUJRAT", "gujraat", "Gujraat", "GUJRAAT"],
        "ENABLED":true,
        "KEY":"gXpj9Y7qw1U5Jp6tdn4vkqduvnMZEjJJ"
    }
}

export const ROUTE_KEY = "wEnlw3OeU3"